module.exports = __webpack_public_path__ + "img/1524823110.29489147.jpg";